import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errorMessage } from "@/lib/api";

export function MemberLogin({ profile, onCreated }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  if (!profile) return null;
  if (profile.account_email) {
    return <p data-testid="member-login-exists" className="mt-10 text-sm text-slate-400 flex items-center justify-center gap-2"><KeyRound className="h-4 w-4 text-[#00E5A3]" /> {profile.name} has their own login: {profile.account_email}</p>;
  }
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post(`/family/profiles/${profile.id}/account`, { email, password }); toast.success(`${profile.name} can now log in with ${email}`); setOpen(false); onCreated(); }
    catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button data-testid="member-login-open" onClick={() => setOpen(true)} className="mt-10 text-sm text-[#FFB800] hover:text-white inline-flex items-center gap-2">
        <KeyRound className="h-4 w-4" /> Give {profile.name} their own login
      </button>
    );
  }
  return (
    <form data-testid="member-login-form" onSubmit={save} className="mt-10 mx-auto max-w-sm rounded-2xl bg-[#151C2C] border border-[#26334D] p-5 text-left space-y-3">
      <p className="text-sm font-semibold">{profile.name}'s own login</p>
      <p className="text-xs text-slate-400">They get the full traveler features on their own login, and still share this family's trip plan and hearts. They count toward the family's 5 devices.</p>
      <Input data-testid="member-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="bg-[#0B0F19] border-[#26334D]" />
      <Input data-testid="member-login-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password (6+ characters)" className="bg-[#0B0F19] border-[#26334D]" />
      <Button data-testid="member-login-submit" disabled={busy} className="w-full rounded-xl bg-[#FF3B6B] hover:bg-[#E0335D] text-white font-semibold">Create login</Button>
    </form>
  );
}
